class LandingPdp extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      swiperSel: '.landing-pdp__slider.swiper',
      thumbsSel: '.landing-pdp__thumbs.swiper',
      form: '.product--order',
      submitBtn: '.product--order__btn',
      submitBtnLoading: 'product--order__btn--loading',
      radioLabels: '.product--order__radio-label-one-time',
      radioInput: 'input.js-one-time-radio',
      showButton: '.show-button',
      buyOnceTitle: '.landing-pdp__buy-once-title',
      subtitle: '.product--details__subtitle',
      orderToday: '.landing-pdp__order-today',
      description: '.product--details__description',
      totalInventory: '.landing-pdp__total-inventory',
      price: '.landing-pdp__price',
      certBy: '.landing-pdp__certified-by',
      altCertBy: 'landing-pdp__certified-by--alt'
    };
  }

  connectedCallback() {
    this.initSwiper();

    this.form = this.querySelector(this.selectors.form);
    this.submitBtn = this.querySelector(this.selectors.submitBtn);
    this.radioLabels = this.querySelectorAll(this.selectors.radioLabels);
    this.showButton = this.querySelector(this.selectors.showButton);
    this.buyOnceTitle = this.querySelector(this.selectors.buyOnceTitle);
    this.subtitle = this.querySelector(this.selectors.subtitle);
    this.orderToday = this.querySelector(this.selectors.orderToday);
    this.description = this.querySelector(this.selectors.description);
    this.totalInventory = this.querySelector(this.selectors.totalInventory);
    this.price = this.querySelector(this.selectors.price);
    this.certBy = this.querySelector(this.selectors.certBy);

    this.submitBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.submitBtn.classList.add(this.selectors.submitBtnLoading);
      this.addToCart(this.form);
    });

    this.showButton.addEventListener('click', () => {
      this.showContent(this.form);
    });

    this.buyOnceTitle.addEventListener('click', () => {
      this.showContent(this.form);
    });

    this.radioLabels.forEach(label => {
      label.addEventListener('click', () => {
        this.form.dataset.quantity = label.querySelector(this.selectors.radioInput).value;
        this.form.dataset.discount = label.querySelector(this.selectors.radioInput).dataset.discount;
      });
    });
  }

  initSwiper() {
    this.thumbsSwiper = new Swiper(this.selectors.thumbsSel, {
      spaceBetween: 8,
      slidesPerView: 5,
      watchSlidesProgress: true,
      breakpoints: {
        640: {
          spaceBetween: 19
        }
      }
    });

    this.landingSlider = new Swiper(this.selectors.swiperSel, {
      spaceBetween: 16,
      autoHeight: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: this.thumbsSwiper,
      }
    });
  }

  async addToCart(form) {
    const prodId = form.dataset.prodId;
    const quantity = form.dataset.quantity || 1;
    const discountCode = form.dataset.discount || '';

    try {
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });
      console.log('🧹 Cart cleared');

      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          discount: discountCode
        }),
      });
      console.log(`🏷️ Discount ${discountCode} applied`);

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: prodId,
          quantity: quantity
        })
      });
    } catch (err) {
      console.error('cart add err:', err);
    } finally {
      window.location.href = '/checkout';
    }
  }

  showContent(form) {
    form.style.display = 'block';
    if (this.subtitle) this.subtitle.style.display = 'none';
    if (this.orderToday) this.orderToday.style.display = 'none';
    if (this.description) this.description.style.display = 'none';
    if (this.totalInventory) this.totalInventory.style.display = 'none';
    if (this.price) this.price.style.display = 'none';
    this.showButton.style.display = 'none';
    this.certBy.classList.add(this.selectors.altCertBy);
  }
}

customElements.define('landing-pdp', LandingPdp);
